import React from 'react';
import { useDispatch } from 'react-redux';

import SelectSizeCategory from '@components/SelectSizeCategory';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { increaseSizeCategorySequence } from '@services/measurementService';

const AddSizeModal = ({
	item,
	setIsAddSize,
	stylesData,
	addDesignIndex,
	setOrderStyles,
	isFromCreateOrder,
	disabled
}) => {
	const dispatch = useDispatch();
	const onAddSize = async (item, payload) => {
		if (item || payload) {
			// Changed condition to allow payload-only updates
			try {
				const newData = [...stylesData];

				const selectedDesign = newData.find((ite) => ite.id === addDesignIndex);

				if (!selectedDesign) {
					return;
				}

				if (payload !== undefined) {
					const sequenceMap = selectedDesign.sizeCategorySequenceMap || {};
					if (!(payload.sizeCategoryId in sequenceMap)) {
						dispatch(openLoader());
						try {
							const data = await increaseSizeCategorySequence(
								payload.productId,
								payload.sizeCategoryId,
								'PP_SAMPLE'
							);
							selectedDesign.sizeCategorySequenceMap = data || sequenceMap;
						} catch {
							selectedDesign.sizeCategorySequenceMap = sequenceMap;
						} finally {
							dispatch(closeLoader());
						}
					}

					let prevColorWiseSizes = selectedDesign.colorWiseSizeQuantityPairList;
					let newColorWiseSizes = payload.colorWiseSizeQuantityPairList;

					// Preserve existing quantities by sizeId (color-agnostic)
					let existingQtyBySizeId = {};
					for (let prevColor of prevColorWiseSizes) {
						for (let prevSize of prevColor.sizeQuantityPairList) {
							existingQtyBySizeId[prevSize.id] = prevSize.quantity;
						}
					}

					// Get updated sizes from first color in payload (sizes are same across all colors)
					const updatedSizeList = (newColorWiseSizes[0]?.sizeQuantityPairList || []).map(
						(size) => ({
							...size,
							quantity: existingQtyBySizeId[size.id] || 0
						})
					);

					// selectedDesign.allSizeResponseList = payload.allSizeResponseList;
					selectedDesign.sizeCategoryResponse = payload.sizeCategoryResponse;
					// Keep existing colors intact, only update their sizeQuantityPairList
					selectedDesign.colorWiseSizeQuantityPairList = prevColorWiseSizes.map((color) => ({
						...color,
						sizeQuantityPairList: updatedSizeList.map((size) => ({ ...size }))
					}));
					selectedDesign.sizeQuantityPairList = updatedSizeList;
					selectedDesign.sizeCategoryId = payload.sizeCategoryId;
				} else {
					selectedDesign.colorWiseSizeQuantityPairList =
						selectedDesign.colorWiseSizeQuantityPairList.map((value) => ({
							...value,
							sizeQuantityPairList: [
								...value.sizeQuantityPairList,
								{ label: item.value, id: item.id, quantity: 0 }
							]
						}));
				}
				setOrderStyles([...newData]);
				//	onClosePopups();
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	const onRemoveSize = (sizeId) => {
		const newData = stylesData.map((design) =>
			design.id === addDesignIndex
				? {
						...design,
						colorWiseSizeQuantityPairList: design.colorWiseSizeQuantityPairList.map((value) => ({
							...value,
							sizeQuantityPairList: value.sizeQuantityPairList.filter(
								(item) => item.id !== sizeId
							)
						}))
					}
				: design
		);
		setOrderStyles(newData);
	};

	return (
		<SelectSizeCategory
			productId={item.productId}
			selectedItem={item}
			setIsAddSize={setIsAddSize}
			onAddSize={onAddSize}
			onRemoveSize={onRemoveSize}
			isFromCreateOrder={isFromCreateOrder}
			disabled={disabled}
		/>
	);
};

export default AddSizeModal;
